<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-toolbar color="transparent" flat>
      <v-btn flat fab icon @click="back()">
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
          <!-- <v-btn :disabled="btnSave" color="green" outline dark @click="onSubmit()">Save</v-btn>
          <v-btn color="red" outline dark @click="back()">Cancel</v-btn> -->
    </v-toolbar>
    
    <v-divider></v-divider>

    <v-container class="form-container elevation-1">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12 md8 style="padding-right:5px">
            <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
              <v-autocomplete
              v-model="selectedDestination"
              :items="destinations"
              color="primary"
              label="Select destination *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
              <!-- <v-autocomplete
              v-model="selectedTheme"
              :items="themes"
              color="primary"
              label="Select tour theme *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
              clearable
            ></v-autocomplete> -->
            <multiselect v-model="value" outline style="height:59px;border-radius:5%" placeholder="Select Theme" label="name" track-by="themeId" :options="options" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
          </v-flex>
         

          <v-flex xs12>
            <v-textarea outline v-model="form.description" label="Description"></v-textarea>
          </v-flex>

          <v-flex xs12 sm12 md2 style="padding-right:5px">
              <v-text-field v-model="form.day" label="Day *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md2 style="padding-right:5px">
              <v-text-field v-model="form.night" label="Night *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md3>
              <v-text-field v-model="form.actualRate" label="Adult Rate *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field v-model="form.regularRate" label="5-11 yrs Rate *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md2>
              <v-text-field v-model="form.rate" label="bellow 2 - 5 yrs *" :rules="emptyRule" required></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md6>
              <v-text-field v-model="form.nightStay" label="Night Stay" ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6>
              <v-text-field v-model="form.journeyDate" label="Date of Journey" ></v-text-field>
          </v-flex>

          <v-flex xs6 sm6 md2>
              <b-form-checkbox v-model="form.stay">Stay</b-form-checkbox>
          </v-flex>
          <v-flex xs6 sm6 md2>
              <b-form-checkbox v-model="form.travel">Travel</b-form-checkbox>
          </v-flex>
          <v-flex xs6 sm6 md2>
              <b-form-checkbox v-model="form.sightseeing">Sightseeing</b-form-checkbox>
          </v-flex>
          <v-flex xs6 sm6 md2>
              <b-form-checkbox v-model="form.breakfast">Breakfast</b-form-checkbox>
          </v-flex>

          <v-flex xs12 sm12 md4>
              <v-autocomplete
              v-model="selectedRate"
              :items="rates"
              color="primary"
              label="Rate this package"
              item-text="rates"
              item-value="rates"
              clearable
            ></v-autocomplete>
          </v-flex>
         
        </v-layout>
        <v-card-actions>
          <v-btn small :disabled="btnSave" color="green" dark @click="onSubmit()">Save & Continue</v-btn>
          <v-btn small color="red" dark @click="back()">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Package",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Tour Package",
          disabled: false,
          to: "/tourPackage"
        },
        {
          text: "Create Package",
          disabled: true,
          to: "/createTourPackage"
        }
      ],

      themes: null,
      selectedTheme: null,

      destinations: null,
      selectedDestination: null,

      rates: [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
      selectedRate: null,

      form: {
        name: null,
        description: null,
        day: null,
        night: null,
        regularRate: null,
        actualRate: null,
        nightStay: null,
        journeyDate: null,
        rate: null,
        stay: false,
        travel: false,
        sightseeing: false,
        breakfast: false
      },

      value: [],
      options: []
    };
  },

  mounted() {
      this.axios
        .get(config.API + "Destinations2", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.destinations = res.data;
        });

        this.axios
        .get(config.API + "ThemeSelections", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.options = res.data;
        });
    },

  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        themeId: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.value.push(tag)
    },
    back() {
      this.$router.go(-1);
    },


    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        let packageCode = "TP" + Math.floor(100000000000 + Math.random() * 900000000000);
        this.axios
          .post(
            config.API + `TourPackages`,
            {
              packageCode: packageCode,
              name: this.form.name,
              description: this.form.description,
              //themeId: this.selectedTheme,
              destinationId: this.selectedDestination,
              day: this.form.day,
              night: this.form.night,
              regularRate: this.form.regularRate,
              actualRate: this.form.actualRate,
              nightStay: this.form.nightStay,
              journeyDate: this.form.journeyDate,
              rate: this.form.rate,
              stay: this.form.stay,
              travel: this.form.travel,
              sightseeing: this.form.sightseeing,
              breakfast: this.form.breakfast,
              rateStar: this.selectedRate,

              packageThemes: this.value
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Tour Package successfully created");
            this.$router.push("/createItinerary/" + packageCode);
            //this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>
